import { IJudgementReducer } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  SET_JUDGEMENT_ADD,
  RESET_JUDGEMENT_STORE,
  SET_EXPERTISE_RAPORT,
  SET_JUDGEMENT_ON_MERITS,
  SET_JUDGEMENT_APPEAL,
  SET_DAHIR_AMOUNT,
  SET_CIVIL_PROCEEDING,
  SET_DAHIR_AMOUNT_CORPO,
  SET_JUDGEMENT_ON_MERITS_APPEAL,
  SET_EXPERTISE_RAPORT_APPEAL,
  SET_JUDGEMENT_ADD_APPEAL,
  SET_JUDGEMENT_ON_MERITS_MULTIPLE,
  SET_APPEAL_ON_MERITS_MULTIPLE,
  RESET_JUDGEMENT_ADD,
  RESET_EXPERT_REPORT,
  RESET_JUDGEMENT_ON_MERITS,
  RESET_MULTIPLE_JUDGEMENT_ON_MERITS,
  RESET_LAWYER_LEGAL_PROCEEDING,
  RESET_LAWYER_STEPS,
} from 'containers/LawyerLegalProceedingsPage/constants';
import { fromJS } from 'immutable';
import { get } from 'lodash';
import { SET_LOCKED_CLAIM } from 'containers/CourtManagerLegalProceedings/constants';

const initState = fromJS({
  judgementAdd: {},
  judgementAddAppeal: {},
  expertiseRaport: {},
  judgementOnMerits: {},
  judgementOnMeritsAppeal: {},
  expertiseRaportAppeal: {},
  judgementAppeal: {},
  dahirAmounts: [],
  civilProceeding: [],
  dahirAmountsCorpo: [],
  judgementOnMeritsMultiple: [],
  appealOnMeritsMultiple: [],
  lockedClaim: null,
});

const lawyerLegalProceedingsReducer = (
  state = initState,
  action: IJudgementReducer,
) => {
  switch (action.type) {
    case SET_JUDGEMENT_ADD:
      return state.set('judgementAdd', fromJS(action.judgementAdd));
    case SET_JUDGEMENT_ADD_APPEAL:
      return state.set('judgementAddAppeal', fromJS(action.judgementAddAppeal));
    case SET_EXPERTISE_RAPORT:
      return state.set('expertiseRaport', fromJS(action.expertiseRaport));
    case SET_EXPERTISE_RAPORT_APPEAL:
      return state.set(
        'expertiseRaportAppeal',
        fromJS(action.expertiseRaportAppeal),
      );
    case SET_JUDGEMENT_ON_MERITS:
      return state.set('judgementOnMerits', fromJS(action.judgementOnMerits));
    case SET_JUDGEMENT_ON_MERITS_MULTIPLE:
      return state.set(
        'judgementOnMeritsMultiple',
        fromJS(action.judgementOnMeritsMultiple),
      );
    case SET_APPEAL_ON_MERITS_MULTIPLE:
      return state.set(
        'appealOnMeritsMultiple',
        fromJS(action.appealOnMeritsMultiple),
      );
    case SET_JUDGEMENT_ON_MERITS_APPEAL:
      return state.set(
        'judgementOnMeritsAppeal',
        fromJS(action.judgementOnMeritsAppeal),
      );
    case SET_JUDGEMENT_APPEAL:
      return state.set('judgementAppeal', fromJS(action.judgementAppeal));
    case SET_DAHIR_AMOUNT:
      return state.set(
        'dahirAmounts',
        fromJS(get(action, ['dahirAmount', 'data'], [])),
      );
    case SET_CIVIL_PROCEEDING:
      return state.set('civilProceeding', fromJS(action.civilProceeding));
    case SET_LOCKED_CLAIM:
      return state.set('lockedClaim', fromJS(action.claimNumber));
    case SET_DAHIR_AMOUNT_CORPO:
      return state.set('dahirAmountsCorpo', fromJS(action.dahirAmountCorpo));
    case RESET_JUDGEMENT_STORE:
      return initState;
    case RESET_JUDGEMENT_ADD: {
      return state.set('judgementAdd', fromJS({}));
    }
    case RESET_EXPERT_REPORT: {
      return state.set('expertiseRaport', fromJS({}));
    }
    case RESET_JUDGEMENT_ON_MERITS: {
      return state.set('judgementOnMerits', fromJS({}));
    }
    case RESET_MULTIPLE_JUDGEMENT_ON_MERITS: {
      return state.set('judgementOnMeritsMultiple', fromJS([]));
    }
    case RESET_LAWYER_STEPS: {
      return state
        .set('judgementOnMeritsMultiple', fromJS([]))
        .set('judgementOnMerits', fromJS({}))
        .set('expertiseRaport', fromJS({}))
        .set('judgementAdd', fromJS({}))
        .set('judgementOnMeritsAppeal', fromJS([]))
        .set('judgementAddAppeal', fromJS({}))
        .set('expertiseRaportAppeal', fromJS({}))
        .set('appealOnMeritsMultiple', fromJS([]));
    }
    case RESET_LAWYER_LEGAL_PROCEEDING: {
      return initState;
    }

    default:
      return state;
  }
};
export default lawyerLegalProceedingsReducer;
